
/**
 * Helper functions for navigation
 */

export const getUserProfilePath = (userId: string) => {
  return `/community/profile/${userId}`;
};
